import { faAngleDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { KeycloakUser } from "../../model/CarbonExternalModels";
import { AppSliceActions } from "../../store/app/appSlice";
import { selectUsers, useCarbonDispatch, useCarbonSelector } from "../../store/carbonStore";
import UserForm from "./UserForm";
import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { Button } from "userful-chronos-common-ui/dist";

interface IProps {
    user: KeycloakUser;
}

export default function UserDropdown(props: IProps) {
    const dispatch = useCarbonDispatch();

    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    const users = useCarbonSelector(selectUsers);
    const allUsers: KeycloakUser[] = [];
    for (const property in users) {
        allUsers.push(users[property].user);
    }

    return (
        <Dropdown>
            <Dropdown.Toggle className="gcm-component-dropdown-switcher" as={Button}>
                <p>{props.user.userProfile.userName}</p>
                <div className="gcm-icon-dropdown-menu-icon-container">
                    <FontAwesomeIcon icon={faAngleDown} />
                </div>
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="userful-icon-dropdown-menu"
                popperConfig={{ strategy: "fixed" }}
                renderOnMount={true}
                style={{ minWidth: "340px" }}
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                {allUsers.length > 1 && (
                    <>
                        {allUsers.map((c) => {
                            if (c.id.value !== props.user.id.value) {
                                return (
                                    <Dropdown.Item
                                        key={c.id.value}
                                        onClick={() => {
                                            dispatch(
                                                AppSliceActions.setAppView({
                                                    type: "USER",
                                                    id: c.id,
                                                }),
                                            );
                                        }}
                                    >
                                        <div className="gcm-icon-dropdown-menu-icon-container">
                                            <FontAwesomeIcon icon={faUser} />
                                        </div>
                                        <p>{c.userProfile.userName}</p>
                                    </Dropdown.Item>
                                );
                            }
                            return null;
                        })}
                        <hr />
                    </>
                )}
                <UserForm type={"DROPDOWN"} permissions={permissions} />
            </Dropdown.Menu>
        </Dropdown>
    );
}
